import {Component, Input, OnInit} from "@angular/core";


@Component({
    selector: 'db-refund-price',
    templateUrl: './refund-price.component.html',
    styleUrls: ['./refund-price.component.scss'],
    standalone: false
})
export class RefundPriceComponent implements OnInit {

  @Input() price: string | number;
  constructor() {
  }

  ngOnInit() {
  }
}
